interface IMarketBuySellPrice {
  price_per_unit: number;
  volume: number;
}

class MarketBestBuySellPrice implements IMarketBuySellPrice {
  price_per_unit: number;
  volume: number;

  constructor(data: Partial<IMarketBuySellPrice>) {
    this.price_per_unit = data.price_per_unit ?? 0;
    this.volume = data.volume ?? 0;
  }

  /** From json to class instance */
  static fromJson(data: any): MarketBestBuySellPrice {
    return new MarketBestBuySellPrice({
      price_per_unit: data.buy_price_per_unit ?? data.sell_price_per_unit ?? 0,
      volume: data.volume,
    });
  }

  copyWith(data: Partial<IMarketBuySellPrice>): MarketBestBuySellPrice {
    return new MarketBestBuySellPrice({
      price_per_unit: data.price_per_unit ?? this.price_per_unit,
      volume: data.volume ?? this.volume,
    });
  }

  get isDtoValid(): boolean {
    return this.price_per_unit > 0 && this.volume > 0;
  }

  get pricePerUnit(): string {
    return this.price_per_unit > 0 ? this.price_per_unit.toString() : '';
  }

  get numOfUnits(): string {
    return this.volume > 0 ? this.volume.toString() : '';
  }
}
export default MarketBestBuySellPrice;
